import type { Config } from './default';

export default {
  mode: 'production',
  maintenance: false,

  googleMapsKey: 'AIzaSyDMjCpQusdoPWLeD7jxkqAxVgJ8s5xJ3Co',
} satisfies Config;
